import { Location, useLocation } from 'react-router-dom';

/* 
  in React router 6 useLocation does not accept generic type for state anymore
  See https://github.com/remix-run/react-router/pull/7326#issuecomment-626418225
*/
export const useTypedLocation = <S>() => useLocation() as Omit<Location, 'state'> & { state: S };
